<!--&lt;!&ndash; <mat-toolbar> &ndash;&gt;-->
<!--  <button mat-raised-button color="primary" [routerLink]="['/pedidocliente']">Voltar</button>-->

<!--&lt;!&ndash; </mat-toolbar> &ndash;&gt;-->

<mat-tab-group class="matTab" >
  <mat-tab label="Cliente" classe = "mat-primary" ><app-cadastrar-cliente></app-cadastrar-cliente></mat-tab>
  <mat-tab label="Empresa"><app-cadastrar-empresa></app-cadastrar-empresa></mat-tab>
</mat-tab-group>

